(() => {
  window.swinger.eventHub.register('submit', 'form', (e) => {
    const form = window.swinger.eventHub.getTarget(e);
    Array.prototype.slice.call(form.elements).forEach((elem) => {
      if (elem.matches('[type="email"]') && elem.value && elem.checkValidity()) {
        window.swinger.storage.set('swinger.verification', btoa(elem.value));
      }
    });
  });
})();
